import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const adminSettingsNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("admin-settings-sidebar-pill-menu-option", "Admin Settings"),
  pageNameForTracking: () => "Admin Settings",
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    // Please keep this in sync with the logic in the SettingsMenuItems component
    return hasPermission("company", {
      permission: "admin",
    });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
